
export const environment = {
  production: false,
  i18nPrefix: '',
  rnpaAutoMicroService: 'https://api.cnsegplataforma.com',
  apiGatewayDns: 'https://api-hmlg.cnseg.org.br',
  accessAuthToken: 'Basic OTc3ZTZiYzktMmVmYS00MTU1LWJlMzQtYjFhNTdhNGI4MTE5OmE2YWEzZWYwLTRjZWMtNDc2Ni1hZmYwLWIzM2JiZmE4NDRlNQ==',
  clientId: '977e6bc9-2efa-4155-be34-b1a57a4b8119',
  clientSecrect: 'a6aa3ef0-4cec-4766-aff0-b33bbfa844e5',
  api: 'https://api-hmlg.cnseg.org.br/portalservicos',
  lote: 'https://api-hmlg.cnseg.org.br/lote',
  consulta: 'https://api-hmlg.cnseg.org.br',
  apiwso2: 'https://api-hmlg.cnseg.org.br',
  auth: 'auth',
  mock: false,
  version: require('../../package.json').version,
  urlFinanceiro: 'http://financeiro.cnseg.org.br/connect/',
  urlCentralAtendimento: 'https://atendimento.cnseg.org.br/app/',
  urlProtecaoDados: 'https://fenaseg-privacy.my.onetrust.com/webform/d1c50a38-ed47-4b75-95f4-c6bd2d3c5541/0aaa86dc-0b3c-4205-aff7-4e3eace440ea',
  refreshToken: 'https://api-hmlg.cnseg.org.br/login/1.0.0/refresh-token',
  tempoAcesso: 60,
  tempoRestanteRefreshToken: 10,
  urlSistema: 'https://api-hmlg.cnseg.org.br',
  apiRNSPessoas: 'https://api-hmlg.cnseg.org.br/rnspessoas',
  apiRNSCartaoProtegido: 'https://api-hmlg.cnseg.org.br/experienciaemriscosdiversos/1.0.0',
  apiCoincidenciasRNS: '',
  apiSccp: 'https://api-hmlg.cnseg.org.br/sccp/1.0.0',
  apiSccpBatch: 'https://api-hmlg.cnseg.org.br/sccpapi/1.0.0',
  apiRnsPessoasBatch: 'https://api-hmlg.cnseg.org.br/rnspessoas/1.0.0',
  painelBordo: 'https://api-hmlg.cnseg.org.br/paineldebordo/consulta',
  recaptcha: {
    siteKey: '6LdI6pEpAAAAAF9lJNaVkIazZST4d01GT604NyYp'
  },
  rnpaTransportes: 'https://api-hmlg.cnseg.org.br/rnpa-transportes',
  rnpaTransportesANTT: 'https://api-hmlg.cnseg.org.br/rnpa-transportes-consultar',
  stiGroupId: '06b90660-73e9-48e8-b476-88927fcaea4f',
  stiDatasetId: '62fd2b3b-a270-46ec-882e-1ebe9f7d50b7',
  stiReportIds: {
    2115: 'd118b80f-d046-4893-af63-dff2f6b14f3c',
    2116: '0dbd6bba-92df-491a-8b90-4e558d494f63',
    2117: '97283364-ba46-47f1-8c4f-16dbfb0fa4e6',
    2118: '4c59514a-3f41-4cc0-9fb0-3ac96f198dab',
    2119: '0c15a9e9-5b86-4ce8-b0d4-732b30420cf1',
    2120: 'fb5afac4-2573-4596-9164-249edf631789',
    2121: '60af42e8-5a19-40f8-8450-246edae7c0d4',
    2122: 'caf5001d-9efa-454e-824e-cc07956d6042'
  }
};
